import { useState, useEffect } from 'react'
import * as S from './PageWatermark.styled'
import { getImageDimensions } from 'utils'

export const PageWatermark = ({
  itemRef,
  setItemWidth,
  setItemHeight,
  image,
  width,
  height,
  opacity,
  ...props
}) => {
  const [imgSrc, setImgSrc] = useState(null)

  const setImage = () => {
    const url = `${process.env.REACT_APP_S3BUCKET_THEME_IMAGES}${image}`

    setImgSrc(url)
  }

  const getDimensions = async (width, src) => {
    try {
      const d = await getImageDimensions(src)
      setItemWidth?.(width)
      setItemHeight?.(width * (d.height / d.width))
    } catch (err) {
      console.error(src, err)
    }
  }

  useEffect(() => {
    if (image) {
      setImage()
    }
    //eslint-disable-next-line
  }, [image])

  useEffect(() => {
    if (imgSrc) {
      getDimensions(width, imgSrc)
    }
    //eslint-disable-next-line
  }, [imgSrc])

  return (
    <S.Image
      ref={itemRef}
      imgSrc={imgSrc}
      width={width}
      height={height}
      opacity={opacity}
      {...props}
    />
  )
}

export default PageWatermark
